<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import Cookie from '@/services/cookie';
    import {getJobViewTemplate} from '@/utils/helpers';

    export default {
        data() {
            return {
                spinner: {
                    get_job: true,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
            }),

            matchJobsFilter() {
                return {
                    job_uuid: this.$_job.uuid,
                };
            },
        },

        async created() {
            if (Cookie.getToken()) {
                await this.$_getMe().then(() => {
                    this.$_getJobEvents();
                });
            }

            const jobUuid = this.$route.params.uuid;
            const title = this.$route.params.title;
            const expired = this.$route.params.expired;

            const jobview = getJobViewTemplate();

            if (expired != 'expired') {
                this.spinner.get_job = true;
                await this.$_getJob({ jobUuid, createToken: true })
                    .then(() => {
                        this.spinner.get_job = false;
                    })
                    .catch(async e => {
                        // let redirect = '/';
                        if (e?.response?.status && e?.response?.status === 404) {
                            await this.$_getExpiredJobs(jobUuid)
                                .then(res => {
                                    if (res.status === 200) {
                                        window.location.href = `/${jobview}/${title}/${jobUuid}/expired/`;
                                    } else {
                                        window.location.href = `/${jobview}/not-found`;
                                    }
                                })
                                .catch(() => {
                                    window.location.href = `/${jobview}/not-found`;
                                });
                        }

                        // window.location.href = redirect;
                    });
            } else {
                this.spinner.get_job = true;
                await this.$_getExpiredJobs(jobUuid)
                    .then(() => {
                        this.spinner.get_job = false;
                    })
                    .catch(async() => {
                        window.location.href = `/${jobview}/not-found`;
                    });
            }

            const url = Cookie.getJobFilter();
            let res;
            if (url && url !== '/') {
                const input = {
                    url: url,
                    facet: 1,
                    allow_backfill: true,
                    page: 1,
                    exclude_uuids: [this.$_job.uuid],
                };
                res = await this.$_searchJobsByUrl(input);
            } else {
                res = await this.$_getMatchedJobs(this.matchJobsFilter);
            }
            this.$_STORE_MATCHED_JOBS(res.search_results.jobs);
        },

        methods: {
            ...mapActions('me', {
                $_getMe: 'getMe',
                $_getJobEvents: 'getJobEvents',
            }),

            ...mapActions('job', {
                $_getJob: 'getJob',
                $_getMatchedJobs: 'getMatchedJobs',
                $_getExpiredJobs: 'getExpiredJobs',
            }),

            ...mapActions('search', {
                $_searchJobsByUrl: 'searchJobsByUrl',
            }),

            ...mapMutations('job', {
                $_STORE_MATCHED_JOBS: 'STORE_MATCHED_JOBS',
            }),
        },
    };
</script>
